window._define('widgets/tabs', ['jquery', 'widgets/baseWidget', 'utils/responsive'], function ($, BaseWidget, responsive) { 'use strict';
    var widgetName = 'tabs',
        selectorClass = 'js-tabs';

    // widget definition
    $.widget('OC.' + widgetName, BaseWidget, {
        _create: function () {
            this._super(selectorClass);

            this._isEnabled = false;
            this.currentTab = null;
            this.eventName = this.isTouch() ? 'tap' : 'click';
            this.elements.$tabs = this.getWidgetElement('tab');
            this.elements.$content = this.getWidgetElement('content');

            this._enableTabs();
            responsive.onChange($.proxy(this._onResponsiveWidthChange, this));

            if (this.options.isEnabled) {
                this.enable();
            }
        },

        isEnabled: function () {
            return this._isEnabled;
        },

        enable: function () {
            if (!this.isEnabled()) {
                this._isEnabled = true;
                this.closeTabs();
                this.elements.$tabs.on(this.eventName, $.proxy(this._onTabSelect, this));
                this._handleDefaultTab();
            }
        },

        disable: function () {
            if (this.isEnabled()) {
                this._isEnabled = false;
                this.closeTabs();
                this.elements.$tabs.off(this.eventName);
            }
        },

        _handleDefaultTab: function () {
            var self = this;
            this.elements.$tabs.each(function (n, element) {
                if ($(element).data('tabsDefault')) {
                    self.selectTab($(element));
                }
            });
        },

        _enableTabs: function () {
            var self = this;
            this.elements.$tabs.each(function (n, element) {
                var $element = $(element),
                    $contentElement = self._getTabContentElement($element);

                if ($contentElement.length) {
                    self.enableTab($element);
                }
            });
        },

        _onResponsiveWidthChange: function () {
            this.closeTabs();
        },

        _getTabContentId: function ($element) {
            return $element.data('tabsContent') || $element.attr('href');
        },

        _getTabContentElement: function ($element) {
            var selector = this._getTabContentId($element);
            return $(selector).first();
        },

        _onTabSelect: function (event) {
            var $tab = $(event.currentTarget);

            event.preventDefault();

            if ($tab.is('.is-active')) {
                this.closeTabs();
            } else {
                this.selectTab($tab);
            }
        },

        enableTab: function ($element) {
            $element.removeClass('is-disabled');
        },

        selectTab: function ($element) {
            if ($element.hasClass('is-active')) {
                return;
            }

            let $contentElement = this._getTabContentElement($element);

            if ($contentElement.length > 0) {
                this.closeTabs();

                $element.addClass('is-active');

                this.currentTab = {
                    $originParentElement: $contentElement.parent(),
                    $content: $contentElement,
                    id: this._getTabContentId($element),
                };

                $contentElement.appendTo(this.elements.$content);

                this.elements.$content.show();

                this._trigger('onSelectTab', null, {
                    currentTab: this.currentTab,
                });

                if ($element.hasClass('mainHeader__tabSearch')) {
                    $('#algolia-search-input').focus();
                }
            }
        },

        closeTabs: function () {
            var currentTab = this.currentTab;

            this.elements.$tabs.removeClass('is-active');
            this.elements.$content.hide();

            if (currentTab) {
                currentTab.$originParentElement.append(currentTab.$content);
                currentTab = null;
                this._trigger('onCloseTabs');
            }
        },
    });

    $('.' + selectorClass)[widgetName]();

    return $.OC[widgetName];
});
